<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">
        Proposal From
        {{ request.service_type ? request.service_type.name : 'N/A' }}
      </h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="partner-modal-section">
        <p class="distance-text">
          Distance: {{ request.distance ? request.distance + 'KM' : 'N/A' }}
        </p>
        <RoutePoints :waypoints="waypoints"></RoutePoints>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-cancel" data-bs-dismiss="modal" aria-label="Close">
        Close
      </button>
      <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...
      </button>
      <button v-else class="btn btn-primary" @click="acceptRequest">
        Accept
      </button>
    </div>
  </div>
</template>

<script>
import RoutePoints from './RoutePoints.vue';
import http from '../../../config/axios';
import { vehicleRequest } from '../../../store/vehicleRequest/vehicleRequest';

export default {
  props: ['request'],
  components: {
    RoutePoints
  },
  data() {
    return {
      isLoading: false,
      waypoints: []
    };
  },
  watch: {
    request() {
      if (this.request.route_map) {
        let routeMap = vehicleRequest.decodeMapData(this.request.route_map);

        if (routeMap?.pickData && routeMap?.dropData) {
          this.waypoints = [...routeMap.pickData, ...routeMap.dropData];
        } else {
          this.waypoints = [];
        }
      } else {
        this.waypoints = [];
      }
    }
  },
  methods: {
    acceptRequest() {
      if (this.request.distance || this.request.modality === 'fleet-variable') {
        this.isLoading = true;
        http
          .patch(
            `v2/partners/triprequestroutes/${this.request.id}?trip_requests_id=${this.request.trip_requests_id}`,
            {
              status: 'Accepted'
            }
          )
          .then((response) => {
            this.isLoading = false;
            this.$emit('refreshData');
            this.$refs.modalCloseBtn.click();
            this.$partnerSwal.quickSuccessAlert.fire({
              title: 'Success!',
              text: response.data?.message
            });
            this.$router.push({
              name: 'vehicle-request-details-id',
              params: {
                trip_request_id: this.request.trip_requests_id,
                route_id: this.request.id
              },
              hash: '#setTRPrice'
            });
          })
          .catch((error) => {
            this.isLoading = false;
            this.$partnerSwal.errorToast.fire({
              title: 'Error!',
              text: error.response.data?.message
            });
          });
      } else {
        this.$partnerSwal.warningToast.fire({
          title: 'Warning!',
          text: 'This Request has no distance. Can not accept.'
        });
      }
    }
  }
};
</script>

<style scoped>
.partner-modal-section .distance-text {
  margin: 9px 0 25px 9px;
  font-size: 14px;
  font-weight: 500;
}
</style>
